import React, { createContext, useContext, useEffect, useState, useCallback } from "react";
import { api } from "../lib/api";
import { useAuth } from "./AuthContext";

const SettingsContext = createContext({ settings: null, refresh: () => {} });

const PUBLIC_DEFAULTS = {
  app_name: "Gestionale 360",
  company: {
    ragione_sociale: "Sa.Gi Group",
    logo_url: null,
    sito_web: "sagigrp.it",
  },
};

export function SettingsProvider({ children }) {
  const { user } = useAuth();
  const [settings, setSettings] = useState(null);

  const refresh = useCallback(async () => {
    try {
      if (user) {
        const { data } = await api.get("/settings");
        setSettings(data);
      } else {
        const { data } = await api.get("/settings/public");
        setSettings({ ...PUBLIC_DEFAULTS, ...data });
      }
    } catch {
      setSettings(PUBLIC_DEFAULTS);
    }
  }, [user]);

  useEffect(() => { refresh(); }, [refresh]);

  return (
    <SettingsContext.Provider value={{ settings, refresh, setSettings }}>
      {children}
    </SettingsContext.Provider>
  );
}

export function useSettings() {
  return useContext(SettingsContext);
}
